import State from 'store/State';
import {
    buildBarRequest,
    MarketDataRequest,
} from 'marketData/MarketDataRequest';

import { PortfolioSelectionWrapper } from 'portfolio/PortfolioSelectionWrapper';
import {
    AppSettingsState,
    SymbologyValues,
} from 'app/store/appSettings/AppSettingsState';
import { selectFillsGraphConfiguration } from 'widgets/fillsGraph/store/configuration/selectors';

export function getFillsGraphMarketDataRequests(
    portfolioSelection: PortfolioSelectionWrapper,
    widgetKey: string,
    appSettings: AppSettingsState,
    state: State
): MarketDataRequest[] {
    const symbol = portfolioSelection.selectedSymbol;

    // We only retrieve external market data for the Fills Graph if there is a single symbol selection...
    if (!symbol) {
        return [];
    }

    const {
        general: { fallbackIndex },
    } = selectFillsGraphConfiguration(state, widgetKey);

    return buildFillsMarketRequests(
        portfolioSelection.symbology,
        appSettings.symbology,
        symbol,
        fallbackIndex
    );
}

export const fillsExternalMarketDataBarSize = 5;

export function buildFillsMarketRequests(
    symbolSymbology: SymbologyValues,
    indexSymbology: SymbologyValues,
    symbol: string,
    index?: string
): MarketDataRequest[] {
    const requestForPriceAndVolume = buildBarRequest(
        symbol,
        symbolSymbology,
        fillsExternalMarketDataBarSize
    );

    const requests: MarketDataRequest[] = [requestForPriceAndVolume];

    if (index) {
        const requestForFallbackIndex = buildBarRequest(
            index,
            indexSymbology,
            fillsExternalMarketDataBarSize
        );
        requests.push(requestForFallbackIndex);
    }

    return requests;
}
